<template>
    <div id="layout-container">
        <div id="left">
            <!-- <div id="topLeft">
              门店检查
            </div> -->
            <!-- 左上角返回工作台按钮 -->
            <div class="back-workbench-btn" @click="goToWorkbench">
                <span class="icon">←</span>
                <span class="text">返回工作台</span>
            </div>
            <div id="inner">

              <el-menu
                v-bind:uniqueOpened="true"
                :default-active="retailogMenuHighLight"
                v-on:select="select"
                background-color="#272727"
                text-color="#fff"
                active-text-color="#ffd04b"
              >
                <div :key="menu.url + '-' + menu.menuCode" v-for="menu in topdoorMenus">
                  <el-submenu v-bind:index="menu.url + '-' + menu.menuCode" v-if="menu.hasSubMenu">
                    <template slot="title">
                      <i :class="menu.icon"></i>
                      <span>{{ menu.menuName }}</span>
                    </template>
                    <el-menu-item-group
                      :key="subMenu.url + '-' + subMenu.menuCode"
                      v-for="subMenu in menu.subMenuList"
                    >
                      <el-menu-item v-bind:index="subMenu.url + '-' + subMenu.menuCode">{{
                          subMenu.menuName
                        }}</el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>

                  <el-menu-item v-bind:index="menu.url + '-' + menu.menuCode" v-else>
                    <i v-bind:class="menu.icon"></i>
                    <span slot="title">{{ menu.menuName }}</span>
                  </el-menu-item>
                </div>
              </el-menu>

            </div>
        </div>
        <div id="right">
            <div id="topRight">
                <!-- <div id="title">{{ name  }}</div> -->
                <div id="login-user">
                    <i class="el-icon-user"></i>{{ name }}
                    <el-button type="text" size="small" @click="loginout">
                        <i class="el-icon-warning-outline"></i>
                        {{ $t('login.logout')}}
                    </el-button>
                </div>
            </div>
            <div id="main">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
    name: 'layout-admin',
    data: function () {
        return {
            topdoorMenus: [],
            menuMap: {},
            // menuTitleMap: JSON.parse(localStorage.getItem("retailogMenuTitleMap"))
        }
    },
    mounted: function () {
        this.initMenu()
    },
    computed: {
        retailogMenuTitle: function () {
          return this.$store.getters.retailogMenuTitle;
        },
        name: function () {
          return localStorage.getItem("userName")
        },
        roleCode: function () {
          return this.$store.getters.roleCode;
        },
        retailogMenuHighLight() {
          return this.$store.getters.retailogMenuHighLight;
        }
    },
    // watch:{
    // $route: function(val){
    // this.$set(this,'current',{path:val.path,title:this.menuMap[val.path]})
    // }
    // },
    methods: {
      initMenu() {
        // 有可能从retailink跳转到这个详情页
        const currentUrl = window.location.href
        if (currentUrl.indexOf('doorLog') !== -1) {
          // 重新设置标题
          this.$store.commit("setMenuTitle", '巡店记录');
          this.$store.commit("setMenuHighLight", '/log/doorLog-7A41C8E7783C');
        }
        let topdoorMenus = JSON.parse(localStorage.getItem("topdoorMenus"));
        this.topdoorMenus = topdoorMenus;
        console.log('this.topdoorMenus', this.topdoorMenus)
      },


        select: function (key) {
          console.log('key', key)
          let [menuKey, menuCode] = key.split('-');
          this.$router.push({ path: `/topdoor/${menuKey}`.replace(/\/+/g, '/'), query: { ut: Date.now() } });
          // 重新设置标题
          // this.$store.commit("setMenuTitle", this.menuTitleMap[menuKey]);
          this.$store.commit("setMenuHighLight", key);
        },
        loginout: function () {
            this.$store.commit("setToken", "");
            this.$store.commit("setAccount", "");
            Cookies.set("token", "");
            Cookies.set("account", "");
            Cookies.set("retailog-roleCode", "");
            // this.$router.push('/login')
            window.location.replace("https://uat.lingshutong.cn/#/login")
        },
        goToWorkbench() {
            window.location.replace("https://uat.lingshutong.cn/#/desktop")
        },
    }
}
</script>

<style scoped lang="scss">
#layout-container {
    --h: 100%;
    --w: 200px;
    --lw: calc(100% - var(--w));
    --th: 40px;
    --mh: calc(100% - var(--th));
    display: flex;
    height: 100%;

    #left {
        width: var(--w);
        max-height: var(--h);
        background-color: #272727;

        #topLeft {
            width: 100%;
            height: var(--th);
            color: #ffd04b;
            text-align: center;
            font-size: 24px;
            line-height: var(--th);
            box-shadow: 0 0 1px 0;
        }

        #inner {
            width: 100%;
            height: calc(100% - var(--th));
            overflow-y: auto;
            scroll-behavior: smooth;

            &::-webkit-scrollbar {
                width: 3px;
                height: 0px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
            }
        }

    }

    #right {
        width: var(--lw);
        height: var(--h);
        background-color: #f1f1f1;

        #topRight {
            width: 100%;
            height: var(--th);
            line-height: var(--th);
            font-size: 16px;
            padding-left: var(--pad);
            padding-right: var(--pad);
            box-shadow: 0 0 1px 0;
            position: relative;

            #title {
                position: absolute;
                left: var(--pad);
            }

            #login-user {
                position: absolute;
                right: var(--pad);
                font-size: 14px;
            }
        }

        #main {
            width: 100%;
            height: var(--mh);
            overflow-x: hidden;

            &::-webkit-scrollbar {
                width: 3px;
                height: 0px;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #c0c4cc;
            }
        }
    }
    .back-workbench-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    color: #fff;
    cursor: pointer;
    border-bottom: 1px solid #333; /* 加一条分隔线，和下面的菜单区分开 */
    transition: background 0.2s;
  }
  .back-workbench-btn:hover {
    background: #333;
  }
  .back-workbench-btn .icon {
    font-size: 18px;
  }
  .back-workbench-btn .text {
    font-size: 18px;
  }
}</style>



// WEBPACK FOOTER //
// src/topdoor/layout/layout-admin.vue